import { render, staticRenderFns } from "./FormAddLabAux.vue?vue&type=template&id=7c9628c3"
import script from "./FormAddLabAux.vue?vue&type=script&lang=js"
export * from "./FormAddLabAux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports